import React, { useEffect, useState } from "react";
import SuperiorImg from "../../../../assets/Images/Mighty.png";
import DependentPartnerImg from "../../../../assets/Images/DependentPartners.png";
import IndependentPartnerImg from "../../../../assets/Images/IndependentPartners.png";
import InferiorImg from "../../../../assets/Images/Weak.png";
import RationalistImg from "../../../../assets/Images/RationalistImg.png";
import PerformerImg from "../../../../assets/Images/PerformerImg.png";
import HarmonizerImg from "../../../../assets/Images/HarmonizerImg.png";
import OptimizerImg from "../../../../assets/Images/OptimizerImg.png";
import { useSelector, useDispatch } from "react-redux";
import SaleRepClassificationCard from "../../../../components/SalesRepClassificationCard/salesRepClassifictationCard";
import PowerPositionCard from "../../../../components/PowerPositionCard/powerPositionCard";
import { RootState } from "../../../../redux/Reducer";
import { Spinner, Table } from "reactstrap";
import MeetingSummary from "../Detailed Negotition Overview/meetingSummary";
import { useNavigate } from "react-router-dom";
import { getAISummaryForCloseNegotiationAction } from "../../../../redux/Action/Action";
import ToastNotifier from "../../../../components/ToastNotifier/toastNotifier";
import { RESET_AI_SUMMARY_FOR_CLOSE_NEGOTIATION } from "../../../../redux/Action/actionTypes";

// Start of component
const CloseNegotiationPage = () => {
    const [powerPositionType, setPowerPositionType] = useState<string>("");
    const [salesRepType, setSalesRepType] = useState<string>("");
    const [meetingAISummary, setMeetingAISummary] = useState<string>("");
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const negotiationContractData = useSelector(
        (state: RootState) => state.dashboardData.closeNegotiaitionData
    );

    const isLoader = useSelector(
        (state: RootState) => state.toastMessageReducer.loading
    );

    const AIsummaryData = useSelector(
        (state: RootState) => state.closeNegotiation?.closeNegotiationAIsummary
    );

    const basicDetails = negotiationContractData.basicDetails;
    const targetDetails = negotiationContractData.targetValue;
    const targetOutcomeAndAchievementDetails = negotiationContractData.others;

    useEffect(() => {
        if (Object.keys(negotiationContractData).length > 0) {
            setPowerPositionType(negotiationContractData.powerPosition.powerPositionTitle);
            setSalesRepType(negotiationContractData.salesRepClassification.salesRepClassificationTitle);
        }
    }, [negotiationContractData]);

    useEffect(() => {
        if (Object.keys(AIsummaryData).length) {
            setMeetingAISummary(AIsummaryData.response);
        }
    }, [AIsummaryData]);

    useEffect(() => {
        setMeetingAISummary("");
    }, []);

    useEffect(() => {
        if (Object.keys(negotiationContractData).length === 0) {
            navigate('/');
        }
    }, []);

    const requestAISummaryHandler = () => {
        dispatch(
            getAISummaryForCloseNegotiationAction({
                RequestSource: "ShortSummary",
                ID: negotiationContractData?.planNegotiationActions?.negotiationId
            })
        );
    }

    const backToOverviewHandler = () => {
        dispatch({ type: RESET_AI_SUMMARY_FOR_CLOSE_NEGOTIATION });
        navigate('/');
    }

    const getMonthName = (monthNumber: number): string => {
        const months = [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];
        return monthNumber >= 1 && monthNumber <= 12 ? months[monthNumber - 1] : "--";
    };

    const userContentHandler = (userName: string = "Superior") => {
        switch (userName) {
            case "Superior":
                return (
                    <ul>
                        <li>
                            <b>Supplier is more dependant</b> on you as a client than you are on the supplier.
                        </li>
                        <li>
                            Your objective must be <b>very ambitious</b> and should beat the
                            price change of the supplier’s input products (e.g. precursors)
                            significantly
                        </li>
                    </ul>
                );
            case "Dependent":
                return (
                    <ul>
                        <li>
                            Both you and the supplier are <b>dependant on each other.</b>
                        </li>
                        <li>
                            Your objective must be <b>ambitious</b> and should{" "}
                            <b>beat the price change</b> of the supplier’s (e.g. precursors)
                        </li>
                    </ul>
                );
            case "Independent":
                return (
                    <ul>
                        <li>Neither you nor the supplier are dependent on each other</li>
                        <li>
                            Your objective should <b>beat the price change</b> of the
                            supplier’s input products (e.g. precursors), without any price
                            premium for the supplier
                        </li>
                    </ul>
                );
            case "Inferior":
                return (
                    <ul>
                        <li>
                            <b>You are more dependent</b> on the supplier than the supplier is on you.
                        </li>
                        <li>
                            Your objective should be <b>oriented toward the price change</b>{" "}
                            of the supplier’s input products (e.g. precursors); negotiating
                            results worse than price change must be avoided
                        </li>
                    </ul>
                );
        }
    };

    const powerPositionCardImgHandler = () => {
        switch (powerPositionType) {
            case "Superior": return SuperiorImg;
            case "Independent": return IndependentPartnerImg;
            case "Dependent": return DependentPartnerImg;
            case "Inferior": return InferiorImg;
            default: return SuperiorImg;
        }
    };

    const saleRepImgHandler = () => {
        switch (salesRepType) {
            case "Rationalist": return RationalistImg;
            case "Performer": return PerformerImg;
            case "Harmonizer": return HarmonizerImg;
            case "Optimizer": return OptimizerImg;
            default: return HarmonizerImg;
        }
    };

    const saleRepCardColorHandler = () => {
        switch (salesRepType) {
            case "Rationalist": return "card1";
            case "Performer": return "card2";
            case "Harmonizer": return "card3";
            case "Optimizer": return "card4";
            default: return "card1";
        }
    };

    const cardContentHandler = () => {
        switch (salesRepType) {
            case "Rationalist": return ["Well prepared", "Fact oriented", "Proud of product and expertise", "In control of his/her emotions"];
            case "Performer": return ["Well prepared", "Relationship oriented", "Knows to adapt", "Talks powerful, yet chooses words carefully"];
            case "Harmonizer": return ["No detailed preparation", "Relationship oriented", "Good listener", "Takes a moment to think before speaking"];
            case "Optimizer": return ["No detailed preparation", "Fact oriented", "Rather impulsive", "Talks spontaneously without much thought"];
            default: return [];
        }
    };

    const subheadingHandler = () => {
        switch (salesRepType) {
            case "Rationalist": return "“The truth of the story lies in the details”";
            case "Performer": return "“Don’t let anything stop you from reaching your goals”";
            case "Harmonizer": return "“Keep calm to achieve your goals”";
            case "Optimizer": return "“Minimal efforts to achieve given goals”";
            default: return "";
        }
    };

    // Render Helpers
    const renderPowerPositionCard = () => (
        <div className="col-3 padding-left-style">
            <span className="close-negotiation-power-position-heading">Power Position</span>
            <PowerPositionCard
                userName={powerPositionType}
                userContent={<>{userContentHandler(powerPositionType)}</>}
                userImage={powerPositionCardImgHandler()}
                cardSelected={powerPositionType}
                cardHandler={() => { }}
            />
        </div>
    );

    const renderSalesRepCard = () => (
        <div className="col-3 padding-left-style">
            <span className="close-negotiation-sales-rep-heading">Sales rep's Negotiation type</span>
            <SaleRepClassificationCard
                classList={saleRepCardColorHandler()}
                cardImg={saleRepImgHandler()}
                cardHeading={salesRepType}
                subHeading={subheadingHandler()}
                cardContent={cardContentHandler()}
                cardSelected={salesRepType}
                cardHandler={() => { }}
                isDetailedView={true}
            />
        </div>
    );

    const renderRequestSummary = () => (
        <div className="row">
            <div className="col-3 p-0">
                <button className="request-summary-box" onClick={requestAISummaryHandler}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="#FFF"
                        className="bi bi-magic"
                        viewBox="0 0 16 16"
                    >
                        <path d="M9.5 2.672a.5.5 0 1 0 1 0V.843a.5.5 0 0 0-1 0zm4.5.035A.5.5 0 0 0 13.293 2L12 3.293a.5.5 0 1 0 .707.707zM7.293 4A.5.5 0 1 0 8 3.293L6.707 2A.5.5 0 0 0 6 2.707zm-.621 2.5a.5.5 0 1 0 0-1H4.843a.5.5 0 1 0 0 1zm8.485 0a.5.5 0 1 0 0-1h-1.829a.5.5 0 0 0 0 1zM13.293 10A.5.5 0 1 0 14 9.293L12.707 8a.5.5 0 1 0-.707.707zM9.5 11.157a.5.5 0 0 0 1 0V9.328a.5.5 0 0 0-1 0zm1.854-5.097a.5.5 0 0 0 0-.706l-.708-.708a.5.5 0 0 0-.707 0L8.646 5.94a.5.5 0 0 0 0 .707l.708.708a.5.5 0 0 0 .707 0l1.293-1.293Zm-3 3a.5.5 0 0 0 0-.706l-.708-.708a.5.5 0 0 0-.707 0L.646 13.94a.5.5 0 0 0 0 .707l.708.708a.5.5 0 0 0 .707 0z" />
                    </svg>
                    <div className="request-summary-text">Summarize Negotiation</div>
                </button>
            </div>
        </div>
    );

    const renderBackToOverview = () => (
        <div className="row">
            <div className="col-3 p-0">
                <button className="back-to-overview-button" onClick={backToOverviewHandler}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 30 30"
                        fill="none"
                        className="back-to-overview-button-icon"
                    >
                        <path
                            d="M11 21L2 12L11 3"
                            stroke="#004A96"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    Back To Overview</button>
            </div>
        </div>
    );

    const renderMeetingSummarySection = () =>
        meetingAISummary?.length > 0 && (
            <div className="row">
                <div className="col-12 p-0">
                    <MeetingSummary summary={meetingAISummary} roundName={""} readOnly={true} />
                </div>
            </div>
        );

    const renderBasicDetails = () => (
        <div className="col-6 padding-left-style">
            <div className="basic-details-container">
                <div className="basic-details-header">Basic Details</div>
                <ul>
                    <li>
                        <div className="basic-details-field-box">
                            <div className="basic-details-field-name">Negotiation Name :</div>
                            <div className="basic-details-field-value">{basicDetails?.name ? basicDetails.name : '--'}</div>
                        </div>
                    </li>
                    <li>
                        <div className="basic-details-field-box">
                            <div className="basic-details-field-name">Category :</div>
                            <div className="basic-details-field-value">{basicDetails?.categoryName ? basicDetails.categoryName : '--'}</div>
                        </div>
                    </li>
                    <li>
                        <div className="basic-details-field-box">
                            <div className="basic-details-field-name">Country Name :</div>
                            <div className="basic-details-field-value">{basicDetails?.countryName ? basicDetails.countryName : '--'}</div>
                        </div>
                    </li>

                    <li>
                        <div className="basic-details-field-box">
                            <div className="basic-details-field-name">Cluster :</div>
                            <div className="basic-details-field-value">{basicDetails?.cluster ? basicDetails.cluster : '--'}</div>
                        </div>
                    </li>
                    <li>
                        <div className="basic-details-field-box">
                            <div className="basic-details-field-name">Supplier :</div>
                            <div className="basic-details-field-value">{basicDetails?.supplierName ? basicDetails.supplierName : '--'}</div>
                        </div>
                    </li>
                    <li>
                        <div className="basic-details-field-box">
                            <div className="basic-details-field-name">Supplier Location :</div>
                            <div className="basic-details-field-value">{basicDetails?.supplierLocation ? basicDetails.supplierLocation : '--'}</div>
                        </div>
                    </li>
                    <li>
                        <div className="basic-details-field-box">
                            <div className="basic-details-field-name">Lead Sales Rep :</div>
                            <div className="basic-details-field-value">{basicDetails?.salesRepLeadName ? basicDetails.salesRepLeadName : '--'}</div>
                        </div>
                    </li>
                    <li>
                        <div className="basic-details-field-box">
                            <div className="basic-details-field-name">Additional Sales Rep :</div>
                            <div className="basic-details-field-value">{basicDetails?.additionalSalesRepNames ? basicDetails.additionalSalesRepNames.split(';').join(', ') : '--'}</div>
                        </div>
                    </li>
                    <li>
                        <div className="basic-details-field-box">
                            <div className="basic-details-field-name">Negotiation Date :</div>
                            <div className="basic-details-field-value">{getMonthName(basicDetails?.negotiationDateMonth) ? getMonthName(basicDetails?.negotiationDateMonth) : '--'} {basicDetails?.negotiationDateYear ? basicDetails.negotiationDateYear : '--'}</div>
                        </div>
                    </li>
                    <li>
                        <div className="basic-details-field-box">
                            <div className="basic-details-field-name">Implementation Date :</div>
                            <div className="basic-details-field-value">{getMonthName(basicDetails?.negotiationImplementationMonth)} {basicDetails?.negotiationImplementationYear ? basicDetails.negotiationImplementationYear : '--'}</div>
                        </div>
                    </li>
                    <li>
                        <div className="basic-details-field-box">
                            <div className="basic-details-field-name">Validity :</div>
                            <div className="basic-details-field-value">{basicDetails?.validityPeriod ? `${basicDetails.validityPeriod} months` : '--'}</div>
                        </div>
                    </li>
                    <li>
                        <div className="basic-details-field-box">
                            <div className="basic-details-field-name">OD :</div>
                            <div className="basic-details-field-value">{basicDetails?.od ? basicDetails.od : '--'}</div>
                        </div>
                    </li>
                    <li>
                        <div className="basic-details-field-box">
                            <div className="basic-details-field-name">Relevant Spend :</div>
                            <div className="basic-details-field-value">{basicDetails?.formatedRelevantSpend ? basicDetails.formatedRelevantSpend : '--'}
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="14"
                                    height="14"
                                    fill="#000"
                                    className="bi bi-currency-euro close-negotiation-amount-logo"
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M4 9.42h1.063C5.4 12.323 7.317 14 10.34 14c.622 0 1.167-.068 1.659-.185v-1.3c-.484.119-1.045.17-1.659.17-2.1 0-3.455-1.198-3.775-3.264h4.017v-.928H6.497v-.936q-.002-.165.008-.329h4.078v-.927H6.618c.388-1.898 1.719-2.985 3.723-2.985.614 0 1.175.05 1.659.177V2.194A6.6 6.6 0 0 0 10.341 2c-2.928 0-4.82 1.569-5.244 4.3H4v.928h1.01v1.265H4v.928z" />
                                </svg>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="basic-details-field-box">
                            <div className="basic-details-field-name">Negotiation Rounds :</div>
                            <div className="basic-details-field-value">{targetDetails?.negotiationRounds}</div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    );

    const renderNegotiationOutcomeTable = () => (
        <div className="row">
            <div className="negotiation-target-outcome-header">Initial negotiation targets Vs Outcome:</div>
            <Table className="custom-table">
                <thead>
                    <tr>
                        <th> </th>
                        <th>Initial Target</th>
                        <th>Outcome</th>
                        <th>Target Achievement</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Price Change</td>
                        <td>{targetDetails?.negotiationTarget != null ? `${targetDetails?.negotiationTarget} %` : "--"}</td>
                        <td>{targetOutcomeAndAchievementDetails?.targetOutcome != null ? `${targetOutcomeAndAchievementDetails?.targetOutcome} %` : "--"}</td>
                        <td>{targetOutcomeAndAchievementDetails?.achievedTargetValue != null ? `${targetOutcomeAndAchievementDetails.achievedTargetValue} %` : "--"}</td>
                    </tr>
                    <tr className="table-td-height">
                        <td>Discount Terms</td>
                        <td>{'--'}</td>
                        <td>{targetOutcomeAndAchievementDetails?.discountTerms ? targetOutcomeAndAchievementDetails.discountTerms : '--'}</td>
                        <td>{'--'}</td>
                    </tr>

                    <tr className="table-td-height">
                        <td>Payment terms</td>
                        <td>{targetDetails?.paymentTerms ? targetDetails.paymentTerms : '--'}</td>
                        <td>{targetOutcomeAndAchievementDetails?.paymentTermsOutcome ? targetOutcomeAndAchievementDetails.paymentTermsOutcome : '--'}</td>
                        <td>{targetOutcomeAndAchievementDetails?.paymentTermsTargetAchieved ? targetOutcomeAndAchievementDetails.paymentTermsTargetAchieved : '--'}</td>
                    </tr>
                    <tr className="table-td-height">
                        <td>Inco terms</td>
                        <td>{targetDetails?.incoTerms ? targetDetails.incoTerms : '--'}</td>
                        <td>{targetOutcomeAndAchievementDetails?.incoTermsOutcome ? targetOutcomeAndAchievementDetails.incoTermsOutcome : '--'}</td>
                        <td>{targetOutcomeAndAchievementDetails?.incoTermsTargetAchieved ? targetOutcomeAndAchievementDetails.incoTermsTargetAchieved : '--'}</td>
                    </tr>
                    <tr className="table-td-height">
                        <td>Local stock</td>
                        <td>{targetDetails?.localStock ? targetDetails.localStock : '--'}</td>
                        <td>{targetOutcomeAndAchievementDetails?.localStockOutcome ? targetOutcomeAndAchievementDetails.localStockOutcome : '--'}</td>
                        <td>{targetOutcomeAndAchievementDetails?.localStockTargetAchieved ? targetOutcomeAndAchievementDetails.localStockTargetAchieved : '--'}</td>
                    </tr>
                </tbody>
            </Table>
        </div>
    );
    // Actual Return JSX
    return (
        <>
            <div className="close-negotiation-container">
                <div className="row">
                    <div className="summary-negotiation-header">
                        Summary of the negotiation{" "}"
                        <span className="negotiation-name">{basicDetails?.name || '--'}</span>"
                    </div>
                </div>

                <div className="row">
                    {renderPowerPositionCard()}
                    {renderSalesRepCard()}
                    {renderBasicDetails()}
                </div>

                {renderNegotiationOutcomeTable()}
                {renderRequestSummary()}
                {renderMeetingSummarySection()}
                {renderBackToOverview()}
            </div>

            <ToastNotifier />
            {isLoader && (<div className="spinner-overlay"><Spinner className="spinner-style" /></div>)}
        </>
    );
};

export default CloseNegotiationPage;